/**
 * NOWROCKY™ — ikony platnosci jako przycisk do kasy
 *
 * Pasek ikon platnosci na karcie produktu (blok `payment-icons`) staje sie
 * przyciskiem: klik dodaje BIEZACY wariant do koszyka i przerzuca na /checkout.
 *
 * Zasady:
 *  - progresywnie: markup to zwykly <a href="/cart/<wariant>:1"> (permalink Shopify),
 *    wiec bez JS klik i tak prowadzi do kasy. JS tylko przejmuje klik, zeby
 *    wziac AKTUALNY wariant i ilosc z formularza produktu.
 *  - delegacja na document — sekcja produktu jest przerenderowywana przy zmianie
 *    wariantu, wiec listener wpiety w element by zginal.
 *  - dane leca z prawdziwego formularza (FormData), wiec lapiemy id wariantu,
 *    ilosc, selling_plan i properties dokladnie tak jak robi to "Dodaj do koszyka".
 *
 * Trzy scenariusze bledu, trzy rozne zachowania:
 *  - blad sklepu (brak stanu, limit ilosci): klikamy prawdziwy przycisk ATC, zeby
 *    motyw pokazal swoj komunikat. Nigdzie nie przerzucamy.
 *  - siec padla albo trwa > 12 s: idziemy na permalink z href, ktory sam prowadzi
 *    do kasy. Klient nie zostaje z martwym przyciskiem.
 *  - brak fetch/AbortController (stara przegladarka): nie ruszamy klikniecia,
 *    href zalatwia sprawe natywnie.
 *
 * UWAGA (sprawdzone na zywo 2026-08-25): motyw deklaruje `const Theme = {...}`
 * w snippets/scripts.liquid. `const` na poziomie skryptu NIE laduje na `window`,
 * wiec `window.Theme` jest undefined — trzeba czytac gole `Theme`. Prefiks jezyka
 * bierzemy przede wszystkim z href-a, ktory Liquid wyrenderowal juz z /en, /zh.
 */
(function () {
  'use strict';

  if (window.__nwrBuyNowReady) return;
  window.__nwrBuyNowReady = true;

  var TRIGGER = '[data-nwr-buy-now]';
  var PERMALINK = /^(.*)\/cart\/\d+:\d+$/;
  var TIMEOUT_MS = 12000;

  function themeRoutes() {
    try {
      return (typeof Theme !== 'undefined' && Theme && Theme.routes) || null;
    } catch (error) {
      return null;
    }
  }

  /** Prefiks jezyka ('' dla polskiego, '/en', '/zh-cn') wprost z href-a linku. */
  function localePrefix(trigger) {
    var match = (trigger.getAttribute('href') || '').match(PERMALINK);
    return match ? match[1] || '' : null;
  }

  function cartAddUrl(trigger) {
    var prefix = localePrefix(trigger);
    if (prefix !== null) return prefix + '/cart/add.js';
    var routes = themeRoutes();
    return (routes && routes.cart_add_url) || '/cart/add.js';
  }

  function checkoutUrl(trigger) {
    var prefix = localePrefix(trigger);
    if (prefix !== null) return prefix + '/checkout';
    var routes = themeRoutes();
    var cart = (routes && routes.cart_url) || '/cart';
    if (/\/cart\/?$/.test(cart)) return cart.replace(/\/cart\/?$/, '/checkout');
    return '/checkout';
  }

  function findForm(trigger) {
    var id = trigger.getAttribute('data-nwr-form');
    var form = id ? document.getElementById(id) : null;
    if (form) return form;
    return document.querySelector('product-form-component form[data-type="add-to-cart-form"]');
  }

  function setBusy(trigger, busy) {
    trigger.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (busy) trigger.classList.add('is-loading');
    else trigger.classList.remove('is-loading');
  }

  /** Powrot z kasy przez "wstecz" wyciaga strone z bfcache — przycisk musi odzyc. */
  window.addEventListener('pageshow', function () {
    var triggers = document.querySelectorAll(TRIGGER);
    for (var i = 0; i < triggers.length; i++) setBusy(triggers[i], false);
  });

  /**
   * Plakietka "ZOSTALY N SZTUKI" (nowrocky-live.js) wstawia sie jako kolejny element
   * flexa w `.product-form-buttons`. Regula motywu nadaje kazdemu dziecku tego rzadu
   * `flex: 1 1 var(--buy-button-preferred-width, 0)`, wiec plakietka konkurowala
   * o miejsce z "DODAJ DO KOSZYKA" i na waskim ekranie rozbijala rzad: selektor ilosci
   * zostawal w gorze, przycisk spadal pod plakietke.
   * Tu przenosimy ja NAD rzad — ilosc i przycisk wracaja do jednej linii.
   * Robimy to tutaj, a nie w nowrocky-live.js, bo tamten plik jest za duzy na jeden
   * zapis przez Admin API; efekt jest ten sam, a plik laduje sie na kazdej karcie produktu.
   */
  function liftStockBadge() {
    var badge = document.querySelector('[data-nwr-stock]');
    if (!badge) return;
    var row = document.querySelector('product-form-component .product-form-buttons');
    if (!row || !row.parentElement) return;
    if (badge.parentElement === row.parentElement && badge.nextElementSibling === row) return;
    row.parentElement.insertBefore(badge, row);
  }

  if (window.MutationObserver) {
    var badgeObserver = new MutationObserver(liftStockBadge);
    badgeObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('DOMContentLoaded', liftStockBadge);
  liftStockBadge();

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;

    var target = event.target;
    if (!target || !target.closest) return;

    var trigger = target.closest(TRIGGER);
    if (!trigger) return;

    // W edytorze motywu klik ma tylko zaznaczac blok, nie wysylac Krola do kasy.
    if (window.Shopify && window.Shopify.designMode) {
      event.preventDefault();
      return;
    }

    // Ctrl/Cmd/Shift + klik i srodkowy przycisk zostawiamy przegladarce.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    // Stara przegladarka: nie przejmujemy klikniecia, href prowadzi do kasy sam.
    if (typeof window.fetch !== 'function' || typeof window.AbortController !== 'function') return;

    var form = findForm(trigger);
    if (!form) return; // brak formularza -> zostaje permalink z href

    event.preventDefault();
    if (trigger.getAttribute('aria-busy') === 'true') return;

    var addToCartButton = form.querySelector('.add-to-cart-button');
    if (addToCartButton && addToCartButton.disabled) return;

    var data = new FormData(form);
    var mainVariantId = data.get('id');
    if (!mainVariantId) return;
    var qty = data.get('quantity') || '1';
    data.set('quantity', qty);

    // 1. Czyscimy wlasciwosci z data
    for (var k of Array.from(data.keys())) {
      if (k.startsWith('properties[')) {
        data.delete(k);
      }
    }

    // 2. Szukamy zaznaczonych dodatkow
    var checkedAddons = document.querySelectorAll('[data-nwr-addon-input]:checked');
    var addonVariants = [];
    var mainProperties = {};

    checkedAddons.forEach(function (chk) {
      var vid = chk.dataset.variantId;
      var itemEl = chk.closest('[data-nwr-addon]');
      var textarea = itemEl ? itemEl.querySelector('[data-nwr-addon-textarea]') : null;
      var customText = (textarea && textarea.value) ? textarea.value.trim() : '';
      var name = chk.dataset.addonName || chk.name.replace(/^properties\[/, '').replace(/\]$/, '');
      var propNameText = textarea ? (textarea.dataset.propName || (name + ' - Tekst')) : '';

      var priceCents = parseInt(chk.dataset.priceCents, 10) || 0; // Zawsze dodajemy wlasciwosc do produktu glownego
      if (name) {
        var propKey = chk.dataset.propertyName ? chk.dataset.propertyName.replace(/^properties\[/, '').replace(/\]$/, '') : name;
        var propVal = chk.value || 'Tak';
        mainProperties[propKey] = propVal;
        data.set('properties[' + propKey + ']', propVal);
        if (customText && propNameText) {
          mainProperties[propNameText] = customText;
          data.set('properties[' + propNameText + ']', customText);
        }
      }

      if (priceCents > 0 && vid && String(vid).trim() !== '' && String(vid).trim() !== 'null' && String(vid).trim() !== 'undefined') {
        addonVariants.push({
          id: Number(String(vid).trim()) || String(vid).trim(),
          quantity: qty,
          name: name,
          customText: customText,
          propNameText: propNameText
        });
      }
    });

    var fetchBody = data;
    var fetchHeaders = {
      Accept: 'application/javascript, application/json',
      'X-Requested-With': 'XMLHttpRequest',
    };

    if (addonVariants.length > 0) {
      var itemsArr = [];
      itemsArr.push({
        id: Number(mainVariantId) || mainVariantId,
        quantity: Number(qty) || 1,
        properties: mainProperties
      });

      // Get the parent product title for addon identification in admin
      var titleEl = document.querySelector('[data-product-title]');
      var productTitle = (titleEl ? titleEl.getAttribute('data-product-title') : null)
        || document.querySelector('h1.product-title, h1.title, h1')?.innerText?.trim()?.split('\n')[0]
        || ('Variant ' + mainVariantId);

      addonVariants.forEach(function (addon) {
        var addonProps = {
          _for: productTitle
        };
        if (addon.customText) {
          addonProps[addon.propNameText] = addon.customText;
        }

        itemsArr.push({
          id: Number(addon.id) || addon.id,
          quantity: Number(addon.quantity) || 1,
          properties: addonProps
        });
      });
      fetchBody = JSON.stringify({ items: itemsArr });
      fetchHeaders['Content-Type'] = 'application/json';
    }

    var discountCodes = [];
    checkedAddons.forEach(function (chk) {
      var dCode = chk.dataset.discountCode ? chk.dataset.discountCode.trim() : '';
      if (!dCode) {
        var priceCents = parseInt(chk.dataset.priceCents, 10) || 0;
        var name = (chk.dataset.addonName || '').toUpperCase();
        if (priceCents < 0 || name.includes('LABEL') || name.includes('METEK')) {
          dCode = 'NOLABELS';
        }
      }
      if (dCode && discountCodes.indexOf(dCode) === -1) {
        discountCodes.push(dCode);
      }
    });

    setBusy(trigger, true);

    var controller = new AbortController();
    var timedOut = false;
    var timer = setTimeout(function () {
      timedOut = true;
      controller.abort();
    }, TIMEOUT_MS);

    fetch(cartAddUrl(trigger), {
      method: 'POST',
      headers: fetchHeaders,
      body: fetchBody,
      signal: controller.signal,
    })
      .then(function (response) {
        return response.json().catch(function () {
          return {};
        });
      })
      .then(function (result) {
        clearTimeout(timer);
        // Sklep odmowil (brak stanu, limit ilosci): niech motyw pokaze swoj komunikat.
        if (result && result.status) {
          setBusy(trigger, false);
          if (addToCartButton) addToCartButton.click();
          return;
        }
        var targetUrl = checkoutUrl(trigger);
        if (discountCodes.length > 0) {
          var sep = targetUrl.indexOf('?') !== -1 ? '&' : '?';
          targetUrl += sep + 'discount=' + encodeURIComponent(discountCodes.join(','));
        }
        window.location.href = targetUrl;
      })
      .catch(function () {
        clearTimeout(timer);
        setBusy(trigger, false);
        // Siec padla albo przekroczylismy 12 s — ostatnia deska: permalink z href.
        var fallbackUrl = trigger.getAttribute('href');
        if (discountCodes.length > 0 && fallbackUrl) {
          var fSep = fallbackUrl.indexOf('?') !== -1 ? '&' : '?';
          fallbackUrl += fSep + 'discount=' + encodeURIComponent(discountCodes.join(','));
        }
        if (timedOut && fallbackUrl) window.location.href = fallbackUrl;
        else if (addToCartButton) addToCartButton.click();
        else if (fallbackUrl) window.location.href = fallbackUrl;
      });
  });
})();
